import type { RouteRecordRaw } from "vue-router";

export const partnersRoutes: RouteRecordRaw[] = [
  {
    path: "/partners",
    component: () => import("../PartnerLayout.vue"),
    children: [
      {
        path: "",
        name: "partners-index",
        component: () => import("./PartnerListPage.vue"),
      },
      {
        path: ":id-:slug",
        name: "partners-show",
        component: () => import("./PartnerDetailPage.vue"),
      },
    ],
  },
];
